"use client";

import styled from "styled-components";
import { positioningCSS, getColor, getFont, borderCSS, flexCSS, transitionCSS } from "../utils";
import { AnyObject } from "../../models";
import {
  ElementPositioningProps,
  ElementFlexProps,
  ElementBorderProps,
  ElementBackgroundProps,
  ElementTransitionProps,
} from "../ComponentProps";
import { VariableComponent } from "..";

type TextProps = {
  id: string;
  as: string;
  display: string;
  font: string;
  background: string;
  color: string;
  textAlign: string;
  fontStyle: string;
  textDecoration: string;
  textTransform: string;
  letterSpacing: string;
  truncate: boolean;
  lineHeight: string | number;
  theme: AnyObject;
  textOverflow: string;
  maxLines: number;
};

type Props = VariableComponent<
  Partial<TextProps> &
    ElementPositioningProps &
    ElementFlexProps &
    ElementBorderProps &
    ElementBackgroundProps &
    ElementTransitionProps
>;

const elementFonts = {
  h1: "ui.mediumTitle",
  h2: "ui.title",
  h3: "ui.regularBold",
  h4: "ui.regularBold",
  label: "ui.smallBold",
  code: "gallery.code",
};

function getFontName(props: Props): string {
  return props.font || elementFonts[props.as] || "ui.regular";
}

export default styled.p.attrs<Props>(({ id, ...props }) => {
  let ellipsisStyles: AnyObject = props.truncate
    ? { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }
    : {};
  if (props.maxLines && props.maxLines > 1) {
    ellipsisStyles = {
      display: "-webkit-box",
      WebkitLineClamp: props.maxLines,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      whiteSpace: "normal",
      wordWrap: "break-word",
    };
  }
  return {
    "data-testid": id || props["data-testid"],
    as: props.as,
    style: {
      ...ellipsisStyles,
      boxSizing: "border-box",
      backgroundColor: getColor(props.background),
      textAlign: props.textAlign,
      fontStyle: props.fontStyle,
      letterSpacing: props.letterSpacing,
      lineHeight: props.lineHeight,
      textDecoration: props.textDecoration,
      textTransform: props.textTransform,
      textOverflow: props.textOverflow,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      color: getColor(props.theme[props.color] ?? props.color, "black"),
    },
  };
})<Props>`
  ${props => getFont(getFontName(props), "ui.regular", props)};
  ${props => positioningCSS({ m: "none", ...props })}
  ${borderCSS}
  ${flexCSS}
  ${transitionCSS}
`;
